import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import GrayPanel from '../../components/GrayPanel';
import { capitalizeFirstLetter } from '../../lib/utils';

import {PanelStyle} from '../../constants';

/**
 * Rodzaj zamierzenia inwestycyjnego Kontener
 */
class IntendedBuildType extends React.Component {


  elseString = ".....................";
  spanStyle = {
    color: "red",
  }

  render_info = key => <span style={this.spanStyle}>{this.props.data[key] ? this.props.data[key] : this.elseString}</span>

  

  render() {
    let {
      leftCol,
      labelCol,
      inputCol,
      inputStyle,
      errorSpanStyle,
      rightCol,
      labelStyle,
      rowStyle,
    } = PanelStyle;

    labelCol = 'col-sm-3';
    inputCol = 'col-sm-5';
    
    const formDict = {
      LocalColor: {
        label: 'Kolor oznaczenia lokalizacji',
      },
      LineColor: {
        label: 'Kolor inwestycji liniowych',
      },
      OccupationWidth: {
        label: 'Szerokość zajętego pasa',
      },
      OccupationArea: {
        label: 'Powierzchnia zajęta'
      }
    };
    
    return (
      <GrayPanel title={ this.props.title }>
        <p>Planowana lokalizacja projektowanego zamierzenia została oznaczona na
           załączonej do wniosku kopii mapy zasadniczej (jednym egzemplarzu) linią 
           koloru: {this.render_info("LocalColor")}. Przewidywany przebieg projektowanych inwestycji 
           liniowych (sieci uzbrojenia, drogi) oznaczono na mapie 
           zasadniczej linią koloru: {this.render_info("LineColor")}. W przypadku realizacji 
           inwestycji liniowej podać przewidywaną do czasowego zajęcia szerokości 
           pasa terenu wzdłuż projektowanej sieci: {this.render_info("OccupationWidth")}, ewentualnie 
           wielkość terenu niezbędnego dla zajęcia pod budynki tymczasowe 
           (np. pas terenu dla ruchu ciężkich samochodów i maszyn budowlanych, 
           place dla składowania materiałów i lokalizację barakowozów): 
           {this.render_info("OccupationArea")}m<sup>2</sup>.
        </p>

        {Object.keys(formDict).map((v, i) => {
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={leftCol} />
              <div className={labelCol}>
                <label style={labelStyle}>{formDict[v].label}</label>
              </div>
              <div className={inputCol}>
               {Object.keys(this.props).indexOf('onChange' + capitalizeFirstLetter(v)) > -1 ? 
                <input
                  style={{...inputStyle, borderColor: Object.keys(this.props.errors).indexOf(v) > -1 ? 'red' : '#ccc' }}
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  onChange={e => this.props['onChange' + capitalizeFirstLetter(v)](e) }
                /> : 
                <input
                  style={{...inputStyle, borderColor: Object.keys(this.props.errors).indexOf(v) > -1 ? 'red' : '#ccc' }}
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  disabled
                />
              }
              
              {/* RENDER ERROS IN SPAN */}
              {Object.keys(this.props.errors).indexOf(v) > -1 ? 
                <span style={errorSpanStyle}>{this.props.errors[v]}</span>
                : null
              }
              </div>
              <div className={rightCol} />
            </div>
          );
        })}
      </GrayPanel>
    )
  }
}


export default IntendedBuildType;


// WEBPACK FOOTER //
// src/containers/LandDevelop/index.jsx